import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const ORDER_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  OMCL: {
    id: "OMCL", // Find Nearby Clinic
    title: "central_orders",
    icon: "MdOutlineShareLocation",
    path: "order-list-central",
    url: "/app/order-management/order-list-central",
    children: {},
  },
  OMC: {
    id: "OMC", // Find Nearby Clinic
    title: "clinic_orders",
    icon: "MdOutlineShareLocation",
    path: "order-list-clinics",
    url: "/app/order-management/order-list-clinics",
    children: {},
  },
  ORDER_HIDE_DROP_OTP: {
    id: "ORDER_HIDE_DROP_OTP",
    title: "order hide drop otp",
    path: "cta",
    RBACDisplayName: "ORDER_HIDE_DROP_OTP",
    RBACDescription: "Hide the drop-OTP column/actions in Order Management (clinic staff view).",
    url: "/app/order-management/hide-drop-otp-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  ORDER_MODULE_CLINIC_USER: {
    id: "ORDER_MODULE_CLINIC_USER",
    title: "order module clinic user",
    path: "cta",
    RBACDisplayName: "ORDER_MODULE_CLINIC_USER",
    RBACDescription: "Treat the current user as a clinic-side user when routing the order module.",
    url: "/app/order-management/clinic-user-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  ORDER_CENTRAL_PERSPECTIVE: {
    id: "ORDER_CENTRAL_PERSPECTIVE",
    title: "order central perspective",
    path: "cta",
    RBACDisplayName: "ORDER_CENTRAL_PERSPECTIVE",
    RBACDescription: "View orders from a central perspective (for_central + source filter).",
    url: "/app/order-management/central-perspective-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  ORDER_CENTRAL_MODULE_ACCESS: {
    id: "ORDER_CENTRAL_MODULE_ACCESS",
    title: "order central module",
    path: "cta",
    RBACDisplayName: "ORDER_CENTRAL_MODULE_ACCESS",
    RBACDescription: "Access the Central Order Module (includes Tele-doctor Rx view).",
    url: "/app/order-management/central-module-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};
export const ORDER_MANAGEMENT_SUB_NAV_ROUTES: IRoutesDefined = {
  ORDER_MANAGEMENT: {
    id: "ORDER_MANAGEMENT",
    title: "Quick Commerce Dashboard",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "QUICK_COMMERCE_DASHBOARD",
    icon: "BsCardChecklist",
    path: "qc-orders",
    url: "/app/qc-orders",
    isVirtual: true,
    children: {},
  },
  ORDER_MANAGEMENT_ACTION: {
    id: "ORDER_MANAGEMENT_ACTION",
    title: "Quick Commerce Dashboard action button",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "ORDER_MANAGEMENT_ACTION",
    icon: "BsCardChecklist",
    path: "qc-orders-a",
    url: "/app/qc-orders-a",
    isVirtual: true,
    children: {},
  },
  TAB_SWITCH_BUTTON: {
    id: "TAB_SWITCH_BUTTON",
    title: "Quick Commerce Dashboard action button",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "TAB_SWITCH_BUTTON",
    icon: "BsCardChecklist",
    path: "qc-orders-r",
    url: "/app/qc-orders-r",
    isVirtual: true,
    children: {},
  },
  SEND_PAYMENT_LINK_ACTION: {
    id: "SEND_PAYMENT_LINK_ACTION",
    title: "Send payment link action button",
    RBACDescription: "Access to send/fetch & copy the payment link for a payment-due order.",
    RBACDisplayName: "SEND_PAYMENT_LINK_ACTION",
    icon: "BsCardChecklist",
    path: "qc-orders-spl",
    url: "/app/qc-orders-spl",
    isVirtual: true,
    children: {},
  },
  QC_TRANSFER_ORDERS: {
    id: "QC_TRANSFER_ORDERS",
    title: "QC and Transfer Orders",
    RBACDescription: "Access to view QC and Transfer orders tabs.",
    RBACDisplayName: "QC and TC Orders",
    icon: "BsCardChecklist",
    path: "qc-orders-qt",
    url: "/app/qc-orders-qt",
    isVirtual: true,
    children: {},
  },
  RX_ORDERS: {
    id: "RX_ORDERS",
    title: "Quick Commerce Dashboard action button",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "RX_ORDERS",
    icon: "BsCardChecklist",
    path: "qc-orders-r",
    url: "/app/qc-orders-r",
    isVirtual: true,
    children: {},
  },
};

export const QC_ORDER_MANAGEMENT_SUB_NAV_ROUTES: IRoutesDefined = {
  QC_TRANSFER_ORDER: {
    id: "QC_TRANSFER_ORDER",
    title: "QC & TC Orders",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "QC & TC Orders",
    icon: "BsCardChecklist",
    path: "qc-transfer-order",
    url: "/app/qc-transfer-order",
    isVirtual: true,
    children: {},
  },
};
export const TRANSFER_SUB_NAV_ROUTES: IRoutesDefined = {
  TRANSFER_ORDERS_ACTION: {
    id: "TRANSFER_ORDERS_ACTION",
    title: "Clinic to Clinic Transfer",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "transfer-orders-action",
    icon: "BsCardChecklist",
    path: "order-transfer-action",
    url: "/app/order-transfer-action",
    isVirtual: true,
    children: {},
  },
};

